<template>
	<svg :width="width" :height="height" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd"
			d="M17.5 53.125C8.375 53.125 3.125 47.875 3.125 38.75V21.25C3.125 12.125 8.375 6.875 17.5 6.875H42.5C51.625 6.875 56.875 12.125 56.875 21.25V38.75C56.875 47.875 51.625 53.125 42.5 53.125H17.5ZM6.875 21.25V38.75C6.875 45.9 10.35 49.375 17.5 49.375H42.5C49.65 49.375 53.125 45.9 53.125 38.75V21.25C53.125 14.1 49.65 10.625 42.5 10.625H17.5C10.35 10.625 6.875 14.1 6.875 21.25Z"
			:fill="color_prop" />
		<path
			d="M24.147 30.1999L16.322 23.9499C15.522 23.2999 15.372 22.1249 16.022 21.3249C16.672 20.5249 17.847 20.3749 18.647 21.0249L26.472 27.2749C28.372 28.7999 31.597 28.7999 33.497 27.2749L41.322 21.0249C42.122 20.3749 43.322 20.4999 43.947 21.3249C44.597 22.1249 44.472 23.3249 43.647 23.9499L35.822 30.1999C34.222 31.5249 32.097 32.1749 29.997 32.1749C27.897 32.1749 25.772 31.5249 24.147 30.1999Z"
			:fill="color_prop" />
	</svg>

</template>

<script>
export default {

	name: 'IconInfo',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '3.75em', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '3.75em', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '#007BFF',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		width() {
			return Number(this.width_prop.substr(0, this.width_prop.length - 2)) * this.sizeMultiplier_prop + this.width_prop.substr(-2)
		},

		height() {
			return Number(this.height_prop.substr(0, this.height_prop.length - 2)) * this.sizeMultiplier_prop + this.height_prop.substr(-2)
		},
	}
}
</script>

<style lang="css" scoped></style>